import { ICON_BASE_PATH } from "@/app/utils/config";
import { type Dispatch, type SetStateAction } from "react";

interface EyeButtonProp {
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  isVisible: boolean;
}

const EyeButton = ({ setIsVisible, isVisible }: EyeButtonProp) => {
  return (
    <button onClick={() => setIsVisible(!isVisible)}>
      <img
        src={
          isVisible
            ? `${ICON_BASE_PATH}eyeopen.svg`
            : `${ICON_BASE_PATH}eyeclose.svg`
        }
        alt="toggle"
        className="cursor-pointer"
      />
    </button>
  );
};

export default EyeButton;
